import {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {compose} from 'recompose';
import * as AuthActions from "../reducers/auth";

class LogoutPage extends Component {

    constructor(props) {
        super(props);
        this.props.dispatch(AuthActions.logout());
        this.props.history.replace("/");
    }

    render() {
        return null
    }

}

LogoutPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
};

export default compose(
    withRouter,
    connect(),
)(LogoutPage);


// WEBPACK FOOTER //
// ./src/js/auth/LogoutPage.js